import { stripHtml } from 'string-strip-html';

function makeArticleSchema(blog) {
    const metaDescription = stripHtml(blog?.metaDescription || '').result,
        image = blog?.featuredImage?.fields,
        imageFile = image && image.file,
        categories = blog?.categories,
        blogCategory = (categories && categories[0]) || blog.category,
        categoryTitle = blogCategory?.title || 'N/A';

    return {
        mainEntityOfPage: {
            '@id': blog.canonicalUrl,
            '@type': 'WebPage',
        },
        headline: blog?.metaTitle,
        image: [`https:${imageFile?.url}?q=70`],

        datePublished: blog.date,
        dateModified: blog.date,
        author: blog?.authors?.map((person) => ({
            name: person?.name || '',
            '@type': 'Person',
        })),
        articleSection: {
            name: categoryTitle,
        },
        publisher: {
            name: 'Viome',
            logo: {
                url: 'https://images.ctfassets.net/qk4l4jfatr3e/1SMJ6OQPL8kTNsze9cXpzS/a0d3137c8503f29d9caabd319a566db8/viome-dark-logo.svg',
                '@type': 'ImageObject',
            },
            '@type': 'Organization',
        },
        description: metaDescription,
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
    };
}

export default function ArticleSchema({ blog }) {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(makeArticleSchema(blog)),
            }}
        />
    );
}
